// extracted by mini-css-extract-plugin
module.exports = {"primary":"layout_primary_3c1Ue"};